module.exports = __webpack_public_path__ + "static/media/arsmaquettepro-bold.b0a65636.woff";